// extracted by mini-css-extract-plugin
export default {"main":"media_main__38CuN","parentDiv":"media_parentDiv__P24h9"};